import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ukRaw from './locales/uk.json';
const uk = ukRaw as Record<string, unknown>;

export default i18n.use(initReactI18next).init({
  resources: {
    uk: { translation: uk },
  },
  fallbackLng: 'uk',
  supportedLngs: ['uk'],
  interpolation: { escapeValue: false },
  detection: {
    order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
    caches: ['localStorage'],
  },
  react: { useSuspense: false },
});
